var _ = require('../util')

_.extend(exports, require('./compile'))
_.extend(exports, require('./transclude'))


/*****************
 ** WEBPACK FOOTER
 ** ../vue/src/compiler/index.js
 ** module id = 11
 ** module chunks = 0
 **/